<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TopStudentCard",
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  methods: {
    studentImage(image) {
      return (new URL(`../../assets/images/top_students/1402/${image}`, import.meta.url)).toString()
    },
  }
})
</script>
<template>
  <div class="top-student-card">
    <v-list-item v-for="student in item" class="item-card my-1" :class="student.isGold ? 'gold-border' : 'opacity'">
      <template v-slot:prepend>
        <v-img
            :src="studentImage(student.backgroundImage)"
            width="70"
            class="mx-3"
        />
      </template>
      <template v-slot:append>
        <p class="rank">{{student.rank}}</p>
      </template>
      <v-list-item-title class="name">
        {{ student.fullName }}
      </v-list-item-title>
      <v-list-item-subtitle class="measure">
        {{ student.measure }}
      </v-list-item-subtitle>
    </v-list-item>
    <!--  OLD SLIDER  -->
    <!--    <v-img-->
    <!--        :src="studentImage(item.backgroundImage)"-->
    <!--        height="100"-->
    <!--        cover-->
    <!--    >-->
    <!--    </v-img>-->
    <!--    <v-avatar-->
    <!--        color="white"-->
    <!--        size="94"-->
    <!--        rounded-->
    <!--        class="rounded-circle mx-auto d-block mx-auto mt-n12"-->
    <!--        style="border: 6px solid #fff"-->
    <!--    >-->
    <!--      <v-img  cover :src="studentImage(item.profileImage)"></v-img>-->
    <!--    </v-avatar>-->
    <!--    <div class="content text-center py-3">-->
    <!--      <h3>-->
    <!--        {{ item.fullName }}-->
    <!--      </h3>-->
    <!--      <p>رتبه {{ item.rank }} کنکور</p>-->
    <!--      <p v-if="item.multiProfessor" class="professor-name">مصاحبه با اساتید کلاسینو</p>-->
    <!--      <p v-else-if="item.professor" class="professor-name">مصاحبه با استاد {{item.professor}} </p>-->
    <!--      <p v-else class="professor-name"> مصاحبه با کلاسینو</p>-->
    <!--      <a :href="item.videoLink" class="btn cl-btn cta-btn blue">-->
    <!--        مشاهده مصاحبه-->
    <!--        <i class="icon-play-live mr-2"></i>-->
    <!--      </a>-->
    <!--    </div>-->
  </div>
</template>

<style scoped lang="scss">
.top-student-card {
  width: 100%;
  .item-card{
    -webkit-backdrop-filter: blur(19px);
    backdrop-filter: blur(19px);
    background-color: rgba(255, 255, 255, 0.2);
    .rank{
      font-weight:900;
      margin-bottom: 0;
      -webkit-text-stroke: 1px rgba(255, 255, 255, 0.12);
      font-size: 4rem;
      color: rgba(255, 255, 255, 0.07);
    }
    .name{
      color: #fff;
      font-weight: 800;
      font-size: 1.2rem;
      margin-bottom: 10px;
    }
    .measure{
      color:#fff;
      font-size: 1rem;

    }
  }
  .gold-border{
    border-style: solid;
    border-width: 2px;
    border-image-source: linear-gradient(106deg, #ffac42 0%, #f90 17%, #ffef8f 60%, #f90 100%);
    border-image-slice: 1;
  }
  .opacity{
    border: solid 2px rgba(255, 255, 255, 0.07);
  }
  //OLD Slider
  //.content {
  //  text-align: center;
  //  margin: 0 auto;
  //  padding: 0 5px 30px 5px;
  //
  //  h3 {
  //    font-size: 1.4rem;
  //    font-weight: 700;
  //    color: rgba(30,30,30,0.49);
  //    margin: 15px 0 0 0;
  //  }
  //
  //  //p {
  //  //  font-size: 1.4rem;
  //  //  font-weight: 800;
  //  //  color: rgba(30,30,30,0.89);
  //  //  margin: 10px 0;
  //  //}
  //
  //  .professor-name{
  //    font-size: 1rem;
  //    font-weight: 800;
  //    color: #808080;
  //    margin: 10px  0 15px;
  //  }
  //}

}
</style>
